<template>
	<div class="ww-userinfo-body">
		<div class="ww-userinfo-head">
			<a :class="{active: currentTpl == 'order'}" href="javascript:;">
				<span class="text-box" @click="getOrder">订单</span>
				<span class="refresh-btn icon icon-shuaxin" @click="refreshOrder" title="刷新订单"></span>
			</a>
			<a :class="{active: currentTpl == 'track'}" href="javascript:;">
				<span class="text-box" @click="getTrackInfo">足迹</span>
			</a>
			<a :class="{active: currentTpl == 'info'}" href="javascript:;">
				<span class="text-box" @click="getUserInfo">客户信息</span>
				<span class="refresh-btn icon icon-shuaxin" @click="refreshUserInfo" title="刷新客户信息"></span>
			</a>
			<a :class="{active: currentTpl == 'goods'}" href="javascript:;">
				<span class="text-box" @click="getGoods">商品推荐</span>
			</a>
		</div>
		<div class="ww-userinfo-body">
			<orderTpl v-show="currentTpl == 'order'"></orderTpl>
			<trackInfoTpl v-show="currentTpl == 'track'"></trackInfoTpl>
			<wwUserInfoTpl v-show="currentTpl == 'info'"></wwUserInfoTpl>
			<wwGoodsTpl ref="wwGoods" v-show="currentTpl == 'goods'"></wwGoodsTpl>
		</div>
	</div>
</template>

<script>
import orderTpl from './order.vue'
import trackInfoTpl from './wwTrackInfo.vue'
import wwUserInfoTpl from './wwUserInfo.vue'
import wwGoodsTpl from './wwGoodsList.vue'
export default {
	name: 'userInfoTpl',
	data () {
		return {
			currentTpl: 'order' // order(订单)、track(足迹)、info(客户信息)、goods(商品推荐)
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		},
		userStatus () {
			return this.$store.state.userStatus;
		}
	},
	components: {
		'orderTpl': orderTpl,
		'trackInfoTpl': trackInfoTpl,
		'wwUserInfoTpl': wwUserInfoTpl,
		'wwGoodsTpl': wwGoodsTpl
	},
	watch: {
		currentConversation: {
			deep: true,
			handler (now, old) {
				if (now.id == old.id) return;
				this.init();
			}
		}
	},
	methods: {
		// 初始化客户信息模版
		init () {
			var self = this;

			if (self.currentConversation.type != 'ww') return;
			self.getOrder();
		},

		// 获取订单
		getOrder () {
			var self = this,
				data = {
					"buyerNick": self.currentConversation.name,
					"sessionId": self.currentConversation.id,
					"shopId": self.currentShop.id
				};

			self.currentTpl = 'order';
			self.$store.commit('changeOrderData', 'load');
			self.$store.commit('changeOrderMark', {});
			self.$store.commit('changeOrderEditAddress', '');

			var key = self.currentConversation.other.kehuId + '-' + self.currentShop.id;
			TJ_DB.get(TJ_DB.ORDER_Table, "'newKey' == " + key, function(result) {
				if (result.length) {
					self.$store.commit('changeOrderData', result[0].data);
				} else {
					self.$axios.post(API_ROOT.baseUrl + '/api/wwim/queryOrderList', data).then(result => {
						if (result.code != 200) {
							alert('获取订单失败');
							self.$store.commit('changeOrderData', []);
						}
					}, response => {
						self.$store.commit('changeOrderData', []);
						alert('获取订单失败');
					})
				}
			});
		},

		// 刷新订单
		refreshOrder () {
			var self = this,
				key = self.currentConversation.other.kehuId + '-' + self.currentShop.id;

			TJ_DB.del(TJ_DB.ORDER_Table, "'newKey' == " + key, function() {
				self.getOrder();
			});
		},

		// 获取足迹
		getTrackInfo () {
			var self = this,
				data = {
					"buyerNick": self.currentConversation.name,
					"sessionId": self.currentConversation.id,
					"shopId": self.currentShop.id
				};

			self.currentTpl = 'track';
			self.$store.commit('changeTrackInfo', 'load');
			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/getTrackInfo', data).then(result => {
				if (result.code != 200) {
					alert('获取足迹失败');
					self.$store.commit('changeTrackInfo', []);
				}
			}, response => {
				self.$store.commit('changeTrackInfo', []);
				alert('获取足迹失败');
			})
		},

		// 获取客户信息
		getUserInfo () {
			var self = this,
				data = {
					"buyerNick": self.currentConversation.name,
					"sessionId": self.currentConversation.id,
					"shopId": self.currentShop.id
				};

			self.currentTpl = 'info';
			self.$store.commit('changeWwUserInfo', 'load');

			TJ_DB.get(TJ_DB.WWUSERINFO_Table, "'kehuId' == " + self.currentConversation.other.kehuId, function(result) {
				if (result.length) {
					self.$store.commit('changeWwUserInfo', result[0]);
				} else {
					self.$axios.post(API_ROOT.baseUrl + '/api/wwim/getUserInfo', data).then(result => {
						if (result.code != 200) {
							alert('获取客户信息失败');
							self.$store.commit('changeWwUserInfo', {});
						}
					}, response => {
						self.$store.commit('changeWwUserInfo', {});
						alert('获取客户信息失败');
					})
				}
			});
		},

		// 刷新客户信息
		refreshUserInfo () {
			var self = this;

			TJ_DB.del(TJ_DB.WWUSERINFO_Table, "'kehuId' == " + self.currentConversation.other.kehuId, function() {
				self.getUserInfo();
			});
		},

		// 商品推荐
		getGoods () {
			var self = this;

			self.currentTpl = 'goods';
			self.$store.commit('changeWwGoodsData', []);
			self.$refs.wwGoods.searchGoods();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/userInfoTpl.vue